import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { LoginPage } from './login.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { NamePageModule } from '../register/name/name.module';

@NgModule({
  imports: [CommonModule, FormsModule, RouterModule, IonicModule, ComponentsModule, NamePageModule],
  declarations: [LoginPage],
  exports: [LoginPage],
})
export class LoginPageModule {}
